import React from 'react';
import { icons } from '@assets/icons/index';
import EdenredNewLabel from '@sharedComponent/Label/newLabel';
import { ALL_EMPLOYEE_CLAIMS, ALL_HR_CLAIMS, ALL_PAYROLL_CLAIMS, DEFAULT_SHOW, PERMISSIONS } from '@constants/app-constants';
import { checkHrSubscription } from './../../../../helpers/index';
import { APP_VARIABLES } from './../../../../constants/app-constants';

export const allMenus = [
	{
		key: 'features',
		label: 'New Features!',
		icon: icons.not_focus.newFeature,
		activeIcon: icons.focus_state.newFeature,
		path: '/new-hr-features/summary',
		isVisible: false,
		roles: 'Payroll',
		isSubscribed: false,
		toShow: [
			PERMISSIONS.MANAGE_EMPLOYEES,
			PERMISSIONS.MANAGE_PAYROLL,
			PERMISSIONS.APPROVE_PAYROLL_REQUEST,
			PERMISSIONS.APPROVE_CARD_CANCELLATION,
			PERMISSIONS.APPROVE_CARD_ORDERS,
			PERMISSIONS.MANAGE_LEAVES,
			PERMISSIONS.MANAGE_DOCUMENTS,
			PERMISSIONS.MANAGE_ANNOUNCEMENTS,
			PERMISSIONS.SETUP_LEAVE_APPROVAL_WORKFLOW_AND_EDIT_LEAVE_BALANCES,
			PERMISSIONS.APPROVE_CARD_REPLACEMENT,
		],
		forSubscribedUsersOnly: true,
		show: [],
		subMenus: [],
		isSelect: false,
		isNavigation: 'payroll',
		chip: true,
	},
	{
		key: 'dashboard',
		label: 'Dashboard',
		icon: icons.not_focus.Gridnew,
		activeIcon: icons.focus_state.Gridnew,
		path: '/',
		isVisible: false,
		roles: 'Payroll',
		isSubscribed: false,
		toShow: [
			PERMISSIONS.MANAGE_EMPLOYEES,
			PERMISSIONS.MANAGE_PAYROLL,
			PERMISSIONS.APPROVE_PAYROLL_REQUEST,
			PERMISSIONS.APPROVE_CARD_REPLACEMENT,
			PERMISSIONS.APPROVE_CARD_CANCELLATION,
			PERMISSIONS.APPROVE_CARD_ORDERS,
		],
		show: [],
		subMenus: [],
		isSelect: false,
		isNavigation: 'payroll',
		cleverTapValue: 'Sidebar_Dashboard_Clicked',
	},
	{
		label: 'Home',
		key: 'home',
		icon: icons.not_focus.Homebank,
		activeIcon: icons.not_focus.Homebank,
		path: '/home',
		isVisible: false,
		roles: 'Employee',
		isSubscribed: false,
		toShow: [
			PERMISSIONS.MANAGE_LEAVES,
			PERMISSIONS.MANAGE_DOCUMENTS,
			PERMISSIONS.MANAGE_ANNOUNCEMENTS,
			PERMISSIONS.SETUP_LEAVE_APPROVAL_WORKFLOW_AND_EDIT_LEAVE_BALANCES,
			...ALL_EMPLOYEE_CLAIMS,
		],
		notToShow: [...ALL_PAYROLL_CLAIMS],
		subMenus: [],
		isSelect: false,
		isNavigation: 'hr',
	},
	{
		label: 'Request Leave',
		key: 'request-leave',
		icon: icons.not_focus.leavenew,
		activeIcon: icons.not_focus.leavenew,
		path: '/employee/request_leave',
		isVisible: false,
		roles: 'Employee',
		isSubscribed: false,
		toShow: [...ALL_EMPLOYEE_CLAIMS],
		notToShow: [...ALL_HR_CLAIMS],
		subMenus: [],
		isSelect: false,
		isNavigation: 'hr',
	},
	{
		key: 'payroll',
		label: 'Payroll',
		icon: icons.not_focus.payrollnew1,
		activeIcon: icons.not_focus.payrollnew,
		claimValue: 'Manage.Payroll',
		cleverTapValue: 'Sidebar_Payroll_Clicked',
		path: (availableSubMenus) => {
			const checkSubscription = checkHrSubscription(JSON.parse(localStorage.getItem(APP_VARIABLES.PROD_SUBSCRIPTIONS)));
			let result = '/';
			if (Array.isArray(availableSubMenus) && availableSubMenus.length > 0) {
				if (availableSubMenus[0]?.key === 'run-payroll') {
					result = checkSubscription === true ? '/payroll-plus' : '/run-payroll';
				} else {
					result = availableSubMenus[0]?.path || '/';
				}
			} else {
				result = '/';
			}
			return result;
		},
		secondaryPath: false,
		isVisible: false,
		roles: 'Payroll',
		isSubscribed: false,
		toShow: [PERMISSIONS.MANAGE_PAYROLL, PERMISSIONS.APPROVE_PAYROLL_REQUEST],
		subMenus: [
			{
				label: 'Run Payroll',
				key: 'run-payroll',
				path: () => {
					const checkSubscription = checkHrSubscription(JSON.parse(localStorage.getItem(APP_VARIABLES.PROD_SUBSCRIPTIONS)));
					let result = checkSubscription === true ? '/payroll-plus' : '/run-payroll';
					return result;
				},
				secondaryPath: false,
				roles: 'Payroll',
				cleverTapValue: 'Sidebar_Run_Payroll_Clicked',
				toShow: [PERMISSIONS.MANAGE_PAYROLL],
				isSelect: false,
			},
			{
				label: 'Payroll Status',
				key: 'payroll-status',
				path: '/payroll/history',
				roles: 'Payroll',
				cleverTapValue: 'Sidebar_Payroll_Status_Clicked',
				toShow: [PERMISSIONS.MANAGE_PAYROLL, PERMISSIONS.APPROVE_PAYROLL_REQUEST],
				isSelect: false,
			},
			{
				label: 'Proof of Funds Transfer',
				key: 'proof-of-funds-transfer',
				path: '/payroll/proof_of_transfer',
				roles: 'Payroll',
				cleverTapValue: 'Sidebar_Proof_Of_Funds_Transfer_Clicked',
				toShow: [PERMISSIONS.MANAGE_PAYROLL, PERMISSIONS.APPROVE_PAYROLL_REQUEST],
				isSelect: false,
			},
			{
				label: 'Approve Requests',
				key: 'payroll-approve-requests',
				path: '/payroll/approve_requests',
				roles: 'Payroll',
				cleverTapValue: 'Sidebar_Approve_Requests_Payroll_Clicked',
				toShow: [PERMISSIONS.APPROVE_PAYROLL_REQUEST, PERMISSIONS.APPROVE_PAYROLL_REQUEST],
				isSelect: false,
			},
			{
				label: 'Payroll Timings',
				key: 'payroll-timings',
				path: '/payroll/timings',
				roles: 'Payroll',
				cleverTapValue: 'Sidebar_Payroll_Timings_Clicked',
				toShow: [PERMISSIONS.MANAGE_PAYROLL, PERMISSIONS.APPROVE_PAYROLL_REQUEST],
				isSelect: false,
			},
			{
				label: 'Our Bank Details',
				key: 'our-bank-details',
				path: '/payroll/bank_details',
				roles: 'Payroll',
				cleverTapValue: 'Sidebar_Our_Bank_Details_Clicked',
				toShow: [PERMISSIONS.MANAGE_PAYROLL, PERMISSIONS.APPROVE_PAYROLL_REQUEST],
				isSelect: false,
			},
			{
				label: 'Salary Reports',
				key: 'salary-reports',
				path: '/salary',
				roles: 'Payroll',
				cleverTapValue: 'Sidebar_Salary_Reports_Clicked',
				toShow: [PERMISSIONS.MANAGE_PAYROLL, PERMISSIONS.APPROVE_PAYROLL_REQUEST],
				isSelect: false,
			},
		],
		isSelect: false,
		isNavigation: 'payroll',
	},
	{
		key: 'employees',
		label: 'Employees',
		icon: icons.not_focus.Usersnew,
		activeIcon: icons.focus_state.Usersnew,
		claimValue: 'Manage.Employees',
		path: (availableSubMenus) => {
			if (Array.isArray(availableSubMenus) && availableSubMenus.length > 0) {
				return availableSubMenus[0]?.path || '/';
			}
			return '/employees/manage_employee';
		},
		isVisible: false,
		roles: 'Payroll',
		isSubscribed: false,
		cleverTapValue: 'Sidebar_Employees_Clicked',
		toShow: [
			PERMISSIONS.MANAGE_EMPLOYEES,
			PERMISSIONS.APPROVE_CARD_ORDERS,
			PERMISSIONS.APPROVE_CARD_REPLACEMENT,
			PERMISSIONS.APPROVE_CARD_CANCELLATION,
		],
		subMenus: [
			{
				label: 'Manage Employees',
				key: 'manage-employees',
				path: '/employees/manage_employee',
				roles: 'Payroll',
				cleverTapValue: 'Sidebar_Manage_Employees_Clicked',
				toShow: [
					PERMISSIONS.MANAGE_EMPLOYEES,
					PERMISSIONS.APPROVE_CARD_ORDERS,
					PERMISSIONS.APPROVE_CARD_REPLACEMENT,
					PERMISSIONS.APPROVE_CARD_CANCELLATION,
				],
				isSelect: false,
			},
			{
				label: 'Card Order Status',
				key: 'card-order-status',
				path: '/employees/card/order/status',
				roles: 'Payroll',
				cleverTapValue: 'Sidebar_Card_Order_Status_Clicked',
				toShow: [
					PERMISSIONS.MANAGE_EMPLOYEES,
					PERMISSIONS.APPROVE_CARD_ORDERS,
					PERMISSIONS.APPROVE_CARD_REPLACEMENT,
					PERMISSIONS.APPROVE_CARD_CANCELLATION,
				],
				isSelect: false,
			},
			{
				label: 'Approve Requests',
				key: 'employees-approve-requests',
				path: '/employees/approve_employee_request',
				roles: 'Payroll',
				cleverTapValue: 'Sidebar_Approve_Requests_Employees_Clicked',
				toShow: [PERMISSIONS.APPROVE_CARD_ORDERS, PERMISSIONS.APPROVE_CARD_REPLACEMENT, PERMISSIONS.APPROVE_CARD_CANCELLATION],
				isSelect: false,
			},
		],
		isSelect: false,
		isNavigation: 'payroll',
	},
	{
		key: 'leaves',
		label: 'Leaves',
		icon: icons.not_focus.leavenew,
		activeIcon: icons.focus_state.leavenew,
		claimValue: 'Manage.Leaves',
		newIcon: <EdenredNewLabel />,
		path: (availableSubMenus) => {
			if (Array.isArray(availableSubMenus) && availableSubMenus.length > 0) {
				return availableSubMenus[0]?.path || '/';
			}
			return '/leaves/leaves_to_approve';
		},
		isVisible: false,
		roles: 'HR',
		isSubscribed: false,
		cleverTapValue: 'Sidebar_Leaves_Clicked',
		toShow: [PERMISSIONS.MANAGE_LEAVES, PERMISSIONS.SETUP_LEAVE_APPROVAL_WORKFLOW_AND_EDIT_LEAVE_BALANCES],
		forSubscribedUsersOnly: true,
		chip: true,
		subMenus: [
			{
				label: 'Leaves to Approve',
				key: 'leavestoapprove',
				path: '/leaves/leaves_to_approve',
				roles: 'HR',
				cleverTapValue: 'Sidebar_Leaves_To_Approve_Clicked',
				toShow: [PERMISSIONS.MANAGE_LEAVES],
				isSelect: false,
			},
			{
				label: 'Leave Statuses',
				key: 'leavestatues',
				path: '/leaves/leaves_statuses',
				roles: 'HR',
				cleverTapValue: 'Sidebar_Leave_Statuses_Clicked',
				toShow: [PERMISSIONS.MANAGE_LEAVES],
				isSelect: false,
			},
			{
				label: 'Request Leave',
				key: 'requestleave',
				path: '/leaves/request_leave',
				roles: 'HR',
				cleverTapValue: 'Sidebar_Request_Leave_Clicked',
				toShow: [PERMISSIONS.MANAGE_LEAVES],
				isSelect: false,
			},
			{
				label: 'Approval Workflow',
				key: 'approvalworkflow',
				path: '/approval-workflow-leave',
				roles: 'HR',
				cleverTapValue: 'Sidebar_Leave_Approval_Workflow_Clicked',
				toShow: [PERMISSIONS.SETUP_LEAVE_APPROVAL_WORKFLOW_AND_EDIT_LEAVE_BALANCES],
				isSelect: false,
			},
		],
		isSelect: false,
		isNavigation: 'hr',
	},

	{
		label: 'Documents',
		key: 'documents',
		icon: icons.not_focus.docnew,
		activeIcon: icons.focus_state.docnew,
		claimValue: 'Manage.Documents',
		path: '/hrdocuments',
		newIcon: <EdenredNewLabel />,
		roles: 'HR',
		isVisible: false,
		isSubscribed: false,
		cleverTapValue: 'Sidebar_HR_Documents_Clicked',
		toShow: [PERMISSIONS.MANAGE_DOCUMENTS],
		subMenus: [],
		forSubscribedUsersOnly: true,
		isSelect: false,
		isNavigation: 'hr',
		chip: true,
	},
	{
		label: 'Payslip',
		key: 'payslip',
		icon: icons.not_focus.Receiptbank,
		activeIcon: icons.not_focus.Receiptbank,
		claimValue: 'View.Payslip',
		path: '/payslip',
		roles: 'Employee',
		isVisible: false,
		isSubscribed: false,
		cleverTapValue: 'Sidebar_Payslip_Clicked',
		toShow: [...ALL_EMPLOYEE_CLAIMS],
		subMenus: [],
		isSelect: false,
		isNavigation: 'hr',
	},

	{
		label: 'Announcements',
		key: 'announcements',
		icon: icons.not_focus.announcenew,
		activeIcon: icons.focus_state.announcenew,
		claimValue: 'Manage.Announcements',
		path: '/new-hr-features/announcement',
		newIcon: <EdenredNewLabel />,
		roles: 'HR',
		isVisible: false,
		isSubscribed: false,
		cleverTapValue: 'Sidebar_Announcements_Clicked',
		toShow: [PERMISSIONS.MANAGE_ANNOUNCEMENTS, ...ALL_EMPLOYEE_CLAIMS],
		subMenus: [],
		forSubscribedUsersOnly: true,
		isSelect: false,
		isNavigation: 'hr',
		chip: true,
	},
	{
		label: 'Company',
		key: 'company',
		icon: icons.not_focus.Buildingnew,
		activeIcon: icons.focus_state.Buildingnew,
		path: (availableSubMenus) => {
			if (Array.isArray(availableSubMenus) && availableSubMenus.length > 0) {
				return availableSubMenus[0]?.path || '/';
			}
			return '/company/company-setting';
		},
		isVisible: false,
		roles: 'Payroll',
		isSubscribed: false,
		cleverTapValue: 'Sidebar_Company_Clicked',
		toShow: [PERMISSIONS.MANAGE_ROLES_AND_PERMISSIONS, ...ALL_HR_CLAIMS, ...ALL_PAYROLL_CLAIMS],
		subMenus: [
			{
				label: 'Company Settings',
				key: 'company-setting',
				path: '/company/company-setting',
				roles: 'Payroll',
				cleverTapValue: 'Sidebar_Company_Settings_Clicked',
				toShow: [...ALL_PAYROLL_CLAIMS],
				forSubscribedUsersOnly: true,
				isSelect: false,
			},
			{
				label: 'Team Permissions',
				key: 'team-permissions',
				path: '/manage_team',
				roles: 'RolesPermissions',
				cleverTapValue: 'Sidebar_Team_Permissions_Clicked',
				toShow: [PERMISSIONS.MANAGE_ROLES_AND_PERMISSIONS],
				isSelect: false,
			},
			{
				label: 'Company Information',
				key: 'company-information',
				path: '/company/information',
				roles: 'Payroll',
				cleverTapValue: 'Sidebar_Company_Information_Clicked',
				toShow: [...ALL_HR_CLAIMS, ...ALL_PAYROLL_CLAIMS],
				isSelect: false,
			},
		],
		isSelect: false,
		isNavigation: 'default',
	},
	{
		label: 'Unemployment Insurance',
		key: 'un-employment-insurance',
		icon: icons.not_focus.security_1_inactive,
		activeIcon: icons.not_focus.security_1_active,
		path: '/un-employment-insurance/employee',
		isVisible: false,
		isSubscribed: false,
		roles: 'Payroll',
		toShow: [DEFAULT_SHOW],
		subMenus: [],
		isSelect: false,
		isNavigation: 'default',
		cleverTapValue: 'Sidebar_Unemployment_Insurance_Clicked',
	},
	{
		type: 'common',
		key: 'know-more',
		path: '/landingpage',
		element: `<div className="experience"><p className="experience-content">Experience better HR and Payroll</p><button>Know more </button></div>`,
		isVisible: false,
		isSelect: false,
		isNavigation: 'default',
		toShow: [DEFAULT_SHOW],
		subMenus: [],
	},

	{
		label: 'Invoice',
		key: 'invoice',
		icon: icons.not_focus.invoice,
		activeIcon: icons.focus_state.InvoiceFocus,
		path: '/proof-of-invoice',
		isVisible: false,
		isSubscribed: false,
		roles: 'Payroll',
		toShow: [...ALL_HR_CLAIMS, ...ALL_PAYROLL_CLAIMS],
		subMenus: [],
		isSelect: false,
		isNavigation: 'bottom',
		cleverTapValue: 'Sidebar_Invoice_Clicked',
	},
	{
		label: 'Refer a Client',
		key: 'referAClient',
		icon: icons.not_focus.ReferClient,
		activeIcon: icons.not_focus.ReferClient,
		chip: true,
		path: 'https://edenred.ae/referral-control-group-lp',
		isVisible: true,
		isSubscribed: false,
		roles: 'Payroll',
		toShow: [...ALL_HR_CLAIMS, ...ALL_PAYROLL_CLAIMS],
		subMenus: [],
		isSelect: false,
		isNavigation: 'bottom',
		cleverTapValue: 'Refer_Client_Button',
	},
	{
		label: 'Useful Files',
		key: 'usefulFiles',
		icon: icons.not_focus.folderheart,
		activeIcon: icons.focus_state.folderheart,
		path: '/employees/useful/files',
		isVisible: false,
		isSubscribed: false,
		roles: 'Payroll',
		toShow: [...ALL_HR_CLAIMS, ...ALL_PAYROLL_CLAIMS],
		subMenus: [],
		isSelect: false,
		isNavigation: 'bottom',
		cleverTapValue: 'Sidebar_Useful_Files_Clicked',
	},
	{
		label: 'Video Tutorials',
		key: 'video-tutorials',
		icon: icons.not_focus.folderheart,
		activeIcon: icons.focus_state.folderheart,
		path: '/videoTutorial',
		isVisible: false,
		isSubscribed: false,
		roles: 'Payroll',
		toShow: [...ALL_HR_CLAIMS, ...ALL_PAYROLL_CLAIMS],
		subMenus: [],
		isSelect: false,
		isNavigation: 'bottom',
		cleverTapValue: 'Sidebar_Video_Tutorial_Clicked',
	},
	{
		label: 'Help',
		key: 'help',
		icon: icons.not_focus.helpnew,
		activeIcon: icons.focus_state.helpnew,
		path: '/help',
		isVisible: false,
		isSubscribed: false,
		roles: 'Payroll',
		toShow: [...ALL_HR_CLAIMS, ...ALL_PAYROLL_CLAIMS],
		subMenus: [],
		isSelect: false,
		isNavigation: 'bottom',
		cleverTapValue: 'Sidebar_Help_Clicked',
	}
];
export const USER_HANDLE_PERMISSION_TYPES = {
	MENUS: 'MENUS',
	SCREENS: 'SCREENS',
};
